module.exports = __webpack_public_path__ + "files/367eb4edc3cf47aba9fa0962ecf33404.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-5.png
// module id = 1391
// module chunks = 59